import React from "react";

import { Button, Form, Stack } from "react-bootstrap";

import HeaderRegistration from "../headerRegistration/HeaderRegistration";
import GoBack from "../goBack/GoBack";

import { t } from "i18next";
import { isValidDate } from "../../../../utils/validation";
import { gestioneSnackbar } from "../../../../utils/common";
import { province } from "../../../../enums/province";
import moment from "moment";

const StepAssociation2 = ({
  nameAssociation,
  setNameAssociation,
  indirizzo,
  setIndirizzo,
  comune,
  setComune,
  provincia,
  setProvincia,
  dateOfFoundation,
  setDateOfFoundation,
  description,
  setDescription,
  nextStep,
  previousStep,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nameAssociation) {
      return gestioneSnackbar(
        true,
        t("validation.mandatory_name_association"),
        "error"
      );
    }

    if (!indirizzo || !comune || !provincia) {
      return gestioneSnackbar(true, t("validation.mandatory_address"), "error");
    }

    if (!isValidDate(dateOfFoundation)) {
      return gestioneSnackbar(true, t("validation.date_not_valid"), "error");
    }

    if (moment(dateOfFoundation).isAfter(moment())) {
      return gestioneSnackbar(true, t("validation.date_not_valid"), "error");
    }

    nextStep();
  };

  return (
    <Stack gap={4} className="py-3">
      <Stack
        gap={3}
        className="d-flex justify-content-center align-items-center w-100"
      >
        <HeaderRegistration
          title={t("registration.create_page_association")}
          subtitle={t("registration.your_association_information")}
        />
        <div>
          <Form onSubmit={(e) => handleSubmit(e)}>
            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="formPlaintextNameAssociation"
            >
              <Form.Control
                className="input-registration"
                maxLength={50}
                type="text"
                placeholder={t("registration.name_association")}
                value={nameAssociation}
                onChange={(e) => setNameAssociation(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                className="input-registration"
                type="text"
                maxLength={150}
                placeholder={t("edit_association.address")}
                value={indirizzo}
                onChange={(e) => setIndirizzo(e.target.value.replace(/,/g, ""))}
                required
              />
            </Form.Group>
            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                className="input-registration"
                type="text"
                maxLength={60}
                placeholder={t("edit_association.country")}
                value={comune}
                onChange={(e) => setComune(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Select
                className="input-registration"
                placeholder={t("edit_association.provincia")}
                value={provincia}
                onChange={(e) => setProvincia(e.target.value)}
                required
              >
                <option value="">{t("edit_association.provincia")}</option>
                {province.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="formPlaintextDateFoundation"
            >
              <Form.Label>{t("registration.date_of_foundation")}</Form.Label>
              <Form.Control
                className="input-registration"
                type="date"
                placeholder={t("registration.date_of_foundation")}
                value={dateOfFoundation}
                onChange={(e) => setDateOfFoundation(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="formPlaintextDescription"
            >
              <Form.Label>
                {t("registration.description_of_association")}
              </Form.Label>
              <Form.Control
                className="input-registration"
                maxLength={1000}
                as="textarea"
                rows={4}
                type="text"
                placeholder={t("registration.description_of_association")}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>
            <Button
              variant="light"
              size="md"
              className="button-registration"
              type="submit"
            >
              {t("common.next")}
            </Button>
          </Form>
        </div>
      </Stack>
      <GoBack previousStep={previousStep} />
    </Stack>
  );
};

export default StepAssociation2;
